import React from 'react';
import { useDispatch } from 'react-redux';
import { useChatWithUserPathname } from '../../../../../../../data/hooks/chat/useChatWithUserPathname';
import { useI18n } from '../../../../../../../data/hooks/i18nHooks';
import Button from '../../../../../../elements/Button/Button';
import LoadChatSessions from '../../../../../../loaders/LoadChatSessions';
import WaitWhileBusy from '../../../../../../WaitWhileBusy';

function OpenChatButton(props) {
    const { user, className = '', style } = props,
        dispatch = useDispatch(),
        i18n = useI18n(),
        href = useChatWithUserPathname(user.user_id ?? user.id);

    return (
        <LoadChatSessions>
            <WaitWhileBusy>
                <Button type="button" className={className} style={style} href={href}>
                    {i18n['label.chat']}
                </Button>
            </WaitWhileBusy>
        </LoadChatSessions>
    );
}

export default OpenChatButton;
